export default "__VITE_ASSET__2ba1fd49__"